<template>
  <div class="onlinetest">
    <div v-if="showloading" style="position: fixed;width: 100%;left: 0;top:0;height: 100vh;background: rgba(34, 34, 34, 0.5);align-items: center;justify-content: center;display: flex;">
      <img src="../assets/img/loading.gif">
    </div>
    <div class="top">
      <img src="../assets/img/avatar.png" style="width: 80px;height: 100px;">
      <div class="info" style="color: #fff;margin-left: 30px;">
        <div class="" style="color: #fff;">
          姓名：×××

        </div>
        <div class="" style="color: #fff;">
          性别：×
        </div>
        <div class="" style="color: #fff;">
          准考证号：1111111111
        </div>
        <div class="" style="color: #fff;">
          证件号码：1111111111111111111
        </div>
      </div>
      <div class="font18 flex1 text-center" style="color: #fff;font-weight: bold;">
        {{title}}
      </div>

    </div>
    <div class="flex">
      <div class="left">
        <template v-for="item in leftList" v-if="item.list.length>0">
          <div class="title font14 text-center" style="margin-top: 10px;">
            {{item.name}}
          </div>
          <div class="list">

            <template v-for="voo,index in item.list">
              <div @click="cindex=voo.index">{{voo.index+1}}
                <span class="star" v-if="!voo.obj.isDone && !voo.obj.isTag ">*</span>
                <span class="doublt" v-if="voo.obj.isTag">?</span>
              </div>
            </template>

          </div>
        </template>

        <div class="des" style="color: #fe0303;padding: 15px;line-height: 26px;">
          说明</br>
          1.题号右方的“✔”符号代表该小题回答正确。</br>
          2.题号右方的“✖”符号代表该小题回答错误。</br>
          3.选择选项的同时自动保存答案。

        </div>
        <div class="text-center"><img src="../assets/img/computericon.png" style="cursor: pointer;" @click="showcomputer=true"></div>
      </div>
      <div class="right flex1">
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==0">
          1、判断题
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==1">
          2、单选题
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==2">
          3、多选题
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==3 || examObject.questionStatus==4">
          4、综合题
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==5">
          5、完形填空题
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==6">
          6、阅读理解PartA
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==7">
          7、阅读理解PartB1
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==8">
         8、阅读理解PartB2
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==9">
          9、翻译
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==10">
          10、作文
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==11">
          11、问题求解
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==12">
          12、条件充分性判断
        </div>
        <div class="line">

        </div>
        <div class="exam">
          <div class="font14" style="font-weight: bold;margin-top: 10px;">
            第{{cindex+1}}题
          </div>
          <template v-if="examObject.questionStatus==0 ||examObject.questionStatus==1 || examObject.questionStatus==2">
            <div class="" style="margin-top: 20px;line-height: 2;" v-html="examObject.questionTitle">

            </div>
            <template v-if="examObject.questionStatus==0">
              <div class="options flex" v-for="item,index in examObject.optionList">
                <input disabled=""  type="radio" name="raido" id="" :value="item.optionId" v-model="ck" @change="handleRadio(index)" />
                <div>
                  <template v-if="index==0">A</template>
                  <template v-if="index==1">B</template>
                  <template v-if="index==2">C</template>
                  <template v-if="index==3">D</template>
                  <template v-if="index==4">E</template>
                  <template v-if="index==5">F</template>
                  、<span v-html="item.optionTitle" style="line-height: 2;"></span></div>
              </div>

            </template>
            <template v-if="examObject.questionStatus==1">
              <div class="options flex" v-for="item,index in examObject.optionList">
                <input disabled="" type="radio" name="raido" id="" :value="item.optionId" v-model="ck" @change="handleRadio(index)" />
                <div>
                  <template v-if="index==0">A</template>
                  <template v-if="index==1">B</template>
                  <template v-if="index==2">C</template>
                  <template v-if="index==3">D</template>
                  <template v-if="index==4">E</template>
                  <template v-if="index==5">F</template>
                  、<span v-html="item.optionTitle" style="line-height: 2;"></span></div>
              </div>

            </template>

            <template v-if="examObject.questionStatus==2">
              <div class="options flex" v-for="item,index in examObject.optionList">
                <input disabled type="checkbox" name="checkboxlist" :id="index" :value="item.optionId" v-model="checkboxlist"
                  @change="handleMoreSelect(index)" />
                <div>
                  <template v-if="index==0">A</template>
                  <template v-if="index==1">B</template>
                  <template v-if="index==2">C</template>
                  <template v-if="index==3">D</template>
                  <template v-if="index==4">E</template>
                  <template v-if="index==5">F</template>
                  、<span v-html="item.optionTitle" style="line-height: 2;"></span></div>
              </div>
            </template>
            <div style="font-weight: bold;margin-top: 50px;margin-bottom: 20px;">答案解析：</div>
            <div v-html="examObject.questionAnalysis" style="line-height: 2;"></div>
          </template>
              <div class="flex">
                <template v-if="examObject.questionStatus==3 || examObject.questionStatus==4">
                  <div class="scrollleft" style="margin-top: 20px;width: 40%;height: 60vh;overflow-y: auto;line-height: 2;font-size: 16px !important;" v-html="examObject.questionTitle">

                  </div>

                  <div style="width: 3px;background-color: #ccc;margin-left: 30px;margin-top: -30px;"></div>
                  <div class="flex1 scrollright" style="margin-left: 30px;height: 60vh;overflow-y: auto;line-height: 2;">
                    <template v-for="voo,cindex in examObject.synthesizeList">
                      <div v-html="(cindex+1)+voo.questionTitle" style="margin-top: 20px;line-height: 2;"></div>
                        <div>
                          <template v-if="voo.questionStatus==1">
                            <div class="options flex" v-for="item,index in voo.optionList">
                              <input disabled="" type="radio" :name="'raido'+cindex" id="" :value="item.optionId" v-model="item.selectedValue"
                                @change="handlemultiRadio()" />
                              <div>
                                <template v-if="index==0">A</template>
                                <template v-if="index==1">B</template>
                                <template v-if="index==2">C</template>
                                <template v-if="index==3">D</template>
                                <template v-if="index==4">E</template>
                                <template v-if="index==5">F</template>
                                、<span v-html="item.optionTitle"></span></div>
                            </div>

                          </template>

                          <template v-if="voo.questionStatus==2">
                            <div class="options flex" v-for="item,index in voo.optionList">
                              <input disabled type="checkbox" name="checkboxlist" :id="index" :value="item.optionId" v-model="item.selectedValue"
                                @change="handlemulticheckboxlist()" />
                              <div>
                                <template v-if="index==0">A</template>
                                <template v-if="index==1">B</template>
                                <template v-if="index==2">C</template>
                                <template v-if="index==3">D</template>
                                <template v-if="index==4">E</template>
                                <template v-if="index==5">F</template>
                                、<span v-html="item.optionTitle"></span></div>
                            </div>

                          </template>
                          <template v-if="voo.questionStatus==3 || voo.questionStatus==4">
                            <textarea value="" placeholder="" />
                            </template>
                            <div style="font-weight: bold;margin-top: 50px;margin-bottom: 20px;">答案解析：</div>
                            <div v-html="voo.questionAnalysis" style="line-height: 2;"></div>
                        </div>
                    	   </template>
                  </div>
                		</template>
                    <template v-if="examObject.questionStatus>4">
                      <div class="scrollleft" ref="scrollleft" style="margin-top: 20px;width: 500px;height: 60vh;overflow-y: auto;line-height: 2.5;" v-html="examObject.questionTitle">

                         </div>

                         <div style="width: 6px;overflow: hidden;background: #a1b5fa;cursor: w-resize;" ref="resizeline"  @mousedown="handleChangeWidth($event)"></div>
                         <div class="flex1 scrollright" style="margin-left: 30px;height: 60vh;overflow-y: auto;">
                           <template v-for="voo,cindex in examObject.gestaltOptionList">
                             <div v-html="(cindex+1)" style="margin-top: 20px;" v-if="examObject.questionStatus==5"></div>
                             <div v-html="(cindex+1 )+'. '+voo.optionsName" style="margin-top: 20px;" v-else></div>
                               <div>
                      <!--           <template v-if="voo.questionStatus==1">
                                   <div class="options flex" v-for="item,index in voo.optionList">
                                     <input type="radio" :name="'raido'+cindex" id="" :value="item.optionId" v-model="item.selectedValue"
                                       @change="handlemultiRadio()" />
                                     <div>
                                       <template v-if="index==0">A</template>
                                       <template v-if="index==1">B</template>
                                       <template v-if="index==2">C</template>
                                       <template v-if="index==3">D</template>
                                       <template v-if="index==4">E</template>
                                       <template v-if="index==5">F</template>
                                       、<span v-html="item.optionTitle"></span></div>
                                   </div>

                                 </template> -->

                                 <template>
                                   <div class="options flex" v-for="item,index in voo.optionList">
                                     <input type="radio" name="checkboxlist" :id="index" :value="item.optionId" v-model="item.selectedValue"
                                       @change="handlemulticheckboxlist()" disabled />
                                     <div style="display: flex;">
                                       <template v-if="index==0">A</template>
                                       <template v-if="index==1">B</template>
                                       <template v-if="index==2">C</template>
                                       <template v-if="index==3">D</template>
                                       <template v-if="index==4">E</template>
                                       <template v-if="index==5">F</template>
                                       、<span v-html="item.options"></span></div>
                                   </div>
                                 </template>
                                 <template v-if="voo.questionStatus==3 || voo.questionStatus==4">
                                   <textarea value="" placeholder="" />
                                   </template>
                               </div>
                               <div style="margin-top:10px;margin-bottom:10px;font-weight:bold">答案解析:</div>
                               <div v-html="voo.analysis"></div>
                           	   </template>
                               <template  v-if="examObject.questionStatus==9 || examObject.questionStatus==10">
                                 <textarea placeholder="请输入您的答案" v-model="examObject.content" disabled style="width: 80%;min-height: 200px;"></textarea>
                               </template>
                         </div>
                    </template>
              </div>
    					<div class="flex options">

    						<span class="prev" v-if="cindex>0" @click="handlePrev()">上一题</span>
    						<span class="prev" v-if="cindex<list.length-1" @click="handleNext()">下一题</span>
    					</div>
    				</div>
    			</div>
    		</div>
        <tips v-if="showTips" @handleCloseTips="showTips=false" @handleSubmit="handleSubmit" :listlength="listlength" :donelist="donelist"></tips>
        <div style="position: fixed;right: 30px;top:50px" v-if="showcomputer"><computer @handleClose="showcomputer=false"></computer></div>
  </div>
</template>

<script>
  import computer from './compute.vue'
  document.onkeydown=function(e){


    if(e.code=='F5'){
      e.preventDefault()
    }

  }
  let timer;
  import tips from './submtiquestiontips.vue'
	export default {
	  name: 'Footer',
    components:{
      tips,
      computer
    },
	  data () {
	    return {
	        data:'',
	        title:'模拟考试',
	        pageNo:1,
	        pageSize:10000000,
				  questionsStatus:this.$route.query.questionsStatus,
				  testQuestionsId:this.$route.query.testQuestionsId,
          storageTag:this.$route.query.storageTag,
          title:this.$route.query.title,
          seconds:this.$route.query.minutes*60,
          minutes:this.$route.query.minutes*60,
				  list:[],
          cindex:-1,
          examObject:{},
          ck:'',
          checkboxlist:[],
          showTips:false,
          listlength:0,
          donelist:0,
          multick:[[]],
          multicheckboxlist:[],
          timeString:'00:00:00',
          totalScore:0,
          showloading:true,
          showcomputer:false,
          leftList:[{
            name:'判断题',
            list:[]
          },
          {
            name:'单项选择题',
            list:[]
          },
          {
            name:'多项选择题',
            list:[]
          },
          {
            name:'计算题',
            list:[]
          },
          {
            name:'综合题',
            list:[]
          },
          {
            name:'完形填空',
            list:[]
          },
          {
            name:'阅读理解PartA',
            list:[]
          },
          {
            name:'阅读理解PartB1',
            list:[]
          },
          {
            name:'阅读理解PartB2',
            list:[]
          },
          {
            name:'翻译',
            list:[]
          },
          {
            name:'作文',
            list:[]
          },
          {
            name:'问题求解',
            list:[]
          },
          {
            name:'条件充分性判断',
            list:[]
          }

          ]
	    }
	  },
	  methods:{

	    getData(){ //获取数据


	      this.$axios.get(this.$common.answerAnalysis_url).then((res)=>{
              this.showloading=false;
	            if(res.data.code==1){
                  var list=JSON.parse(res.data.data.content);
                  list.forEach((item,index)=>{
                    this.leftList[item.questionStatus].list.push({
                        index:index,
                        obj:item
                    })
                    this.leftList[item.questionStatus].questionScore=item.questionScore
                  })
                      list.forEach((item)=>{

                              item.isright=item.optionList.every((voo)=>{return voo.optionAnswerStatus==Boolean(voo.selected)})
                             // item.isdone=item.optionList.some((voo)=>{return voo.selected})

                      })

	                this.list=list;
                  this.listlength=list.length;
                  this.cindex=0;
                  console.log(this.totalScore)
	            }
	            else {
	              alert(res.data.msg)
	            }
	      })
	    },
      handleNext(){  //下一题
        this.cindex++
      },
      handlePrev(){  //上一次
        this.cindex--
      },

	  },
	  created(){

      this.getData();

	  },
    watch:{
      seconds(val){
        if(val<=0){

          clearInterval(timer);
          this.handleSubmit();
        }
        else {
          let h=Math.floor(this.seconds/60/60);
          let i=Math.floor(this.seconds/60);
              i=i-h*60;
          let s=this.seconds%60;
              h=h>9?h:'0'+h;
              i=i>9?i:'0'+i;
              s=s>9?s:'0'+s;
          this.timeString=h+":"+i+':'+s
        }
      },
      cindex(val){
        this.$forceUpdate()
        this.examObject=this.list[val];
        console.log(this.examObject)
        var list=this.examObject.optionList.filter((item)=>{
             return item.selected
        })
        if(this.examObject.questionStatus==1 || this.examObject.questionStatus==0){ //单选
          if(list.length>0){
            this.ck=list[0].optionId
          }
          else {
            this.ck=''
          }
        }
        else {
          if(list.length>0){
              this.checkboxlist=list.map((item)=>{
                return item.optionId
              })
          }
          else {
            this.checkboxlist=[];
          }
        }

        var scrollleft=document.querySelector(".scrollleft");
        var scrollright=document.querySelector(".scrollright")
            scrollleft && (scrollleft.scrollTop=0);
            scrollright && (scrollright.scrollTop=0);
      }
    },
    computed:{
        errorQuestionStatus(){
          if(this.questionsStatus==1){

              return 1
          }
          if(this.questionsStatus==2){

              return 2
          }
          if(this.questionsStatus==3){

              return 3
          }
          if(this.questionsStatus==4){

              return 4
          }
          if(this.questionsStatus==5){

              return 4
          }
          if(this.questionsStatus==6){

              return 5
          }
          if(this.questionsStatus==7){

              return 5
          }
        }
    }
	}
</script>

<style scoped="">
  .onlinetest {
  	background-color: #ddebf6;
  }
  .top {
  	height: 120px;
  	background-color: #4fa7ff;
  	padding: 0 30px;
  	display: flex;
  	align-items: center;
  }
  .btn {
  	font-size: 14px;
  	width: 80px;
  	line-height: 40px;
  	background-color: #ffcd34;
  	text-align: center;
  	border: 1px solid #000;
    cursor: pointer;
  }
  .left {
  	width: 420px;
  	border: 1px solid #ccc;
  	background-color: #fff;
  	padding-bottom: 30px;
  }
  .right {
  	border: 1px solid #ccc;
  	margin-left: 10px;
  }
  .title {
  	background-color: #5ea3d7;
  	line-height: 40px;
  	border-radius: 2px;
  	font-weight: bold;
  }
  .list {
  	display: flex;
  	flex-wrap: wrap;


  }
  .list div {
  	width: 28px;
  	height: 28px;
  	background-color: #ddebf6;
  	margin-right: 10px;
  	display: inline-block;
  	line-height: 28px;
  	font-size: 14px;
  	text-align: center;
  	margin-top: 10px;
    cursor: pointer;
    position: relative;

  }
  .star {
  	color: #0058ED;
    position: absolute;
  }
  .doublt {
  	font-size: 11px;
  	color: red;
  	position: absolute;
  	display: inline-block;

  }
  .line {
  	height: 1px;
  	background-color: #ccc;
  	width: 100%;
  }
  .exam {
  	padding-left: 40px;
  }
  .options {
  	align-items: center;
  	margin-top: 30px;
  	color: #101010;

  }
  .options input {
  	margin-right: 10px;
  	width: 15px;
  	height: 15px;
  }
  .prev {
  	font-size: 14px;
  	width: 95px;
  	height: 40px;
  	line-height: 40px;
  	background-color: #fff;
  	border: 1px solid #ccc;
  	text-align: center;
  	margin-left: 25px;
  	cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/viewAnswer.vue